
export const chatColors = [
    'archer',
    'berserker',
    'cavalry',
    'crossbowman',
    'ensign',
    'footman',
    'knight',
    'light-cavalry',
    'marshal',
    'mercenary',
    'pikeman',
    'royal-guard',
    'scout',
    'swordsman',
    'warrior-priest',
];

export interface IChatUser {
    username: string;
    color: string;
}

export interface IChatState {
    state: {
        colors: string[];
        expanded: boolean;
        gameId: number | null;
        lastColorIndex: number;
        messages: string[];
        readMessages: string[];
        show: boolean;
        users: IChatUser[];
    };
    mutations: {

    };
    actions: {

    };
}

export interface IChatMessageResponse {
    createdAt: string;
    id: string;
    playerId: number;
    message: string;
    username: string;
}
